import React from 'react';
import { SortType } from '@home/enums/common';
import SortByIcon from './index';

const AscDemo: React.FC = () => {
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <SortByIcon sortType={SortType.Asc} />
      <span>升序</span>
    </div>
  );
};

const DescDemo: React.FC = () => {
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <SortByIcon sortType={SortType.Desc} />
      <span>降序</span>
    </div>
  );
};

const DisabledDemo: React.FC = () => {
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <SortByIcon sortType={SortType.Desc} disabled />
      <span>禁用状态</span>
    </div>
  );
};

const ForceNoneDemo: React.FC = () => {
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <SortByIcon sortType={SortType.Asc} forceSortTypeNone />
      <span>强制无排序（sortType=Asc 但显示无排序图标）</span>
    </div>
  );
};

export const demoConfig = [
  {
    title: '升序排序',
    description: '展示升序排列图标',
    code: `<SortByIcon sortType={SortType.Asc} />`,
    element: <AscDemo />,
  },
  {
    title: '降序排序',
    description: '展示降序排列图标',
    code: `<SortByIcon sortType={SortType.Desc} />`,
    element: <DescDemo />,
  },
  {
    title: '禁用状态',
    description: '展示禁用状态的排序图标',
    code: `<SortByIcon sortType={SortType.Desc} disabled />`,
    element: <DisabledDemo />,
  },
  {
    title: '强制无排序',
    description: '当 forceSortTypeNone 为 true 时，忽略 sortType，始终显示无排序图标',
    code: `<SortByIcon sortType={SortType.Asc} forceSortTypeNone />`,
    element: <ForceNoneDemo />,
  },
];

export default demoConfig;
